import { useNavigate } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import {
  RELATED_PERMISSIONS_SAVEFORM,
  ROUTER_PATHS,
  TABLE_CONSTANTS_COLUMS,
} from '@/shared';
import { useFetchUsuariosSistema } from '@/shared/actions/erp/administration/usuarios';
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
} from '@/shared/components/ui';
import {
  useCheckPermissions,
  useTableServerSideFiltering,
} from '@/shared/hooks';
import { useTableFilter } from '@/shared/hooks/useTableFilter';
import { UsuariosSistemaGET } from '@/shared/interfaces';
import { hasAllPermissions, hasPermission } from '@/shared/utils';
import { useUiConfirmModalStore } from '@/store/ui';
import { useColumnsUsuarioSistema } from '../../shared/hooks';

export type UsuariosSistemaPageProps = {};

const UsuariosSistemaPage: React.FC<UsuariosSistemaPageProps> = () => {
  useCheckPermissions(PermissionsEnum.auth_view_user);
  const returnUrlUsuariosSistemaPage =
    ROUTER_PATHS.administration.usuariosNav;
  const navigate = useNavigate();

  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  ///* global state
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );

  ///* mutations

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  ///* fetch data
  const {
    data: usuariosSistemaPagingRes,
    isLoading,
    isRefetching,
  } = useFetchUsuariosSistema({
    enabled: true,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      razon_social: searchTerm,
      ...filterObject,
    },
  });

  ///* handlers
  const onEdit = (user: UsuariosSistemaGET) => {
    setConfirmDialog({
      isOpen: true,
      title: 'Editar Usuario',
      subtitle: '¿Está seguro que desea editar este registro?',
      onConfirm: () => {
        setConfirmDialogIsOpen(false);
        navigate(`${returnUrlUsuariosSistemaPage}/editar/${user.id}`);
      },
    });
  };

  // const onDelete = (user: UsuariosSistemaGET) => {
  //   setConfirmDialog({
  //     isOpen: true,
  //     title: 'Eliminar Grupo de Sistema',
  //     subtitle: '¿Está seguro que desea eliminar este registro?',
  //     onConfirm: () => {
  //       setConfirmDialogIsOpen(false);
  //       deleteGrupoSistema.mutate(user.id!);
  //     },
  //   });
  // };

  ///* columns
  const { columnsSystemUser } = useColumnsUsuarioSistema();

  return (
    <SingleTableBoxScene
      title="Usuarios"
      urlRedirect={`${returnUrlUsuariosSistemaPage}/crear`}
      enableRedirect={hasPermission(PermissionsEnum.auth_add_user)}
    >
      <CustomSearch
        onChange={onChangeFilter}
        value={globalFilter}
        cleanFilter={cleanFilter}
        text="por nombre"
      />


      <GeneralTable<UsuariosSistemaGET>
        columns={columnsSystemUser}
        data={usuariosSistemaPagingRes?.data.data || []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={usuariosSistemaPagingRes?.data?.count}
        ///* filters - server side
        enableSorting={false}
        // crud
        showCustomActionBtnSpace={false}
        enableEditing={true}
        actionsColumnSize={TABLE_CONSTANTS_COLUMS.ACTIONCOLUMN_WIDTH}
        positionActionsColumn="first"
        enableColumnActions={hasAllPermissions([
          PermissionsEnum.auth_change_user,
          ...RELATED_PERMISSIONS_SAVEFORM,
        ])}
        canEdit={hasAllPermissions([
          PermissionsEnum.auth_change_user,
          ...RELATED_PERMISSIONS_SAVEFORM,
        ])}
        onEdit={onEdit}
        canDelete={false}
        
      />
    </SingleTableBoxScene>
  );
};

export default UsuariosSistemaPage;
